import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { getSnapshot } from 'mobx-state-tree';
import { AvForm } from 'availity-mobx-reactstrap-validation';

import { default as FormState } from 'js/stores/pages/UserDashboardPageModalState';
import ErrorDisplay from 'js/components/common/ErrorDisplay';

import Container from './Container';
import Title from './Title';
import Icon from './Icon';
import Button from './Button';

@observer
export default class SafariWarning extends Component {

  render() {
    return (
      <Container>
        <AvForm onValidSubmit={this.props.state.closeSafariWarning}>
          <Icon name="warning" />

          <Title>Safari Warning</Title>

          <p>
            Popups may be disabled by your browser.
            Please click on the window icon in the address bar to enable popups on this page.
            After that, please try again.
          </p>

          <Button isLoading={false} disabled={false} autoFocus type="submit">
            OK
          </Button>

        </AvForm>
      </Container>
    );
  }
}
